// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"285de681a60c028c444b","931":"fe09410817b417315f47"}[chunkId] + ".js";
};